import { Redirect, Switch, useLocation, useRouteMatch } from "react-router-dom";
import React, { createContext, useEffect, useState } from "react";
import ProtectedRoutes from "../protectedRoutes";
import ActiveBookingsPage from "../pages/Dashboard/Bookings/ActiveBookingsPage";
import PoliceReportsPage from "../pages/Dashboard/PoliceReportsPage";
import AllBookingsPage from "../pages/Dashboard/Bookings/AllBookingsPage";
import EditBookingPage from "../pages/Dashboard/Bookings/EditBookingPage";
import StayDetailsPage from "../pages/Dashboard/Bookings/StayDetailsPage";
import EditGuestPage from "../pages/Dashboard/Bookings/EditGuestPage";
import BookingSettingsPage from "../pages/Dashboard/Settings/BookingSettingsPage";
import GateLogsPage from "../pages/Dashboard/GateLogsPage";
import DepositCardsPage from "../pages/Dashboard/DepositCardsPage";
import AccessKeysPage from "../pages/Dashboard/AccessKeys/AccessKeysPage";
import StatsPage from "../pages/Dashboard/StatsPage";
import OnlineReservationsPage from "../pages/Dashboard/OnlineReservations/OnlineReservationsPage";
import DashboardLayout from "../pages/Dashboard/DashboardLayout";
import EditOnlineReservationPage from "../pages/Dashboard/OnlineReservations/EditOnlineReservationPage";
import ParkingSlotsPage from "../pages/Dashboard/ParkingSlots/ParkingSlotsPage";
import TestDebugPage from "../pages/Dashboard/TestDebugPage";
import EditBookingInvoicePage from "../pages/Dashboard/Bookings/EditBookingInvoicePage";
import DailyCheckinPage from "../pages/Dashboard/DailyCheckin/DailyCheckinPage";
import BookingPlannerPage from "../pages/Dashboard/Bookings/BookingPlannerPage";
import EditOnlineReservationInvoicePage from "../pages/Dashboard/OnlineReservations/EditOnlineReservationInvoicePage";
import ScrollTop from "../components/ScrollTop";
import BookingPlannerSettingsPage from "../pages/Dashboard/Settings/BookingPlanner/BookingPlannerSettingsPage";
import axios from "../config/axios";
import { linkBuilder } from "src/global/navigationHelper";
import EmailSettingsPage from "../pages/Dashboard/Settings/Email/EmailSettingsPage";
import PriceListSettingsPage from "../pages/Dashboard/Settings/PriceList/PriceListSettingsPage";
import OnlineReservationsSettingsPage from "../pages/Dashboard/Settings/OnlineReservation/OnlineReservationsSettingsPage";
import AccountingInvoicesPage from "src/pages/Dashboard/Accounting/InvoicesPage";
import EditStayPage from "../pages/Dashboard/Bookings/EditStayPage";
import BusinessSettingsPage from "src/pages/Dashboard/Settings/Business/BusinessSettingsPage";
import LocalTaxDailyReportsPage from "src/pages/Dashboard/LocalTaxDailyReports/LocalTaxDailyReportsPage";

export const DashboardContext = createContext(null);

const DashboardRoutes = () => {
  let { path } = useRouteMatch();
  const location = useLocation();

  const [businessSettings, setBusinessSettings] = useState({ settings: null });
  const defaultPath = businessSettings?.settings?.business
    ?.parking_slots_enabled
    ? "/dashboard/bookings/planner"
    : "/dashboard/bookings/active-bookings";

  useEffect(() => {
    axios
      .get(`/api/v1/businesses/global_settings.json`)
      .then(function (response) {
        setBusinessSettings(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  }, []);

  if (!businessSettings?.settings?.business) {
    return <></>;
  }

  return (
    <DashboardContext.Provider value={businessSettings}>
      <DashboardLayout>
        <ScrollTop />
        <Switch>
          {defaultPath === "/dashboard/bookings/active-bookings" ? (
            <ProtectedRoutes
              exact
              path={`${path}/`}
              component={ActiveBookingsPage}
            />
          ) : (
            <ProtectedRoutes
              exact
              path={`${path}/`}
              component={BookingPlannerPage}
            />
          )}
          <ProtectedRoutes path={`${path}/stats`} component={StatsPage} />
          <ProtectedRoutes
            path={`${path}/police-reports`}
            component={PoliceReportsPage}
          />
          <ProtectedRoutes
            path={`${path}/local-tax-daily-reports/:tab?`}
            component={LocalTaxDailyReportsPage}
          />
          <ProtectedRoutes
            path={`${path}/bookings/planner`}
            component={BookingPlannerPage}
          />
          <ProtectedRoutes
            path={`${path}/bookings/active-bookings`}
            component={ActiveBookingsPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/bookings/`}
            component={AllBookingsPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/bookings/new`}
            component={EditOnlineReservationPage}
          />
          <ProtectedRoutes
            path={`${path}/stays/new`}
            component={EditStayPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/stays/:id/`}
            component={StayDetailsPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/stays/:id/edit`}
            component={EditStayPage}
          />
          <ProtectedRoutes
            path={`${path}/stays/:stayId/bookings/:id/edit`}
            component={EditBookingPage}
          />
          <ProtectedRoutes
            path={`${path}/stays/:stayId/guests/new`}
            component={EditGuestPage}
          />
          <ProtectedRoutes
            path={`${path}/stays/:stayId/guests/:id/edit`}
            component={EditGuestPage}
          />
          <ProtectedRoutes
            path={`${path}/stays/:stayId/invoices/:id`}
            component={EditBookingInvoicePage}
          />
          <ProtectedRoutes path={`${path}/gatelogs`} component={GateLogsPage} />
          <ProtectedRoutes
            path={`${path}/deposit-cards`}
            component={DepositCardsPage}
          />
          <ProtectedRoutes
            path={`${path}/access-keys`}
            component={AccessKeysPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/reservations`}
            component={OnlineReservationsPage}
          />
          <Redirect
            exact
            from={`${path}/reservations/new`}
            to={{
              pathname: linkBuilder("/dashboard/bookings/new"),
              state: location.state,
            }}
          />
          <ProtectedRoutes
            path={`${path}/reservations/:id/edit`}
            component={EditOnlineReservationPage}
          />
          <ProtectedRoutes
            path={`${path}/reservations/:online_reservation_id/invoices/:id/edit`}
            component={EditOnlineReservationInvoicePage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/parking_slots`}
            component={ParkingSlotsPage}
          />
          <ProtectedRoutes
            exact
            path={`${path}/test`}
            component={TestDebugPage}
          />
          <ProtectedRoutes exact path={`/`} component={ActiveBookingsPage} />
          <ProtectedRoutes
            path={`${path}/daily-checkin`}
            component={DailyCheckinPage}
          />
          <ProtectedRoutes
            path={`${path}/bookingsettings`}
            component={BookingSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/settings/business`}
            component={BusinessSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/settings/booking-planner`}
            component={BookingPlannerSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/settings/email`}
            component={EmailSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/settings/pricelist/:tab?`}
            component={PriceListSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/settings/reservation`}
            component={OnlineReservationsSettingsPage}
          />
          <ProtectedRoutes
            path={`${path}/accounting/invoices`}
            component={AccountingInvoicesPage}
          />
          {/*<ProtectedRoutes path={`${path}/settings/pricelist/age_groups`} component={AgeGroupsPage}/>*/}
        </Switch>
      </DashboardLayout>
    </DashboardContext.Provider>
  );
};

export default DashboardRoutes;
